// extracted by mini-css-extract-plugin
export var active = "_m9-2";
export var recordingDot = "_m9-1";
export var recordingIndicator = "_m9-0";